module.exports = __webpack_public_path__ + "img/product-clip.d2cda413.png";